import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/Panton/stylesheet.css';
import Home from './screens/Home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>
);
